(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["feature"] && !Shopify.designMode) return;
  try {
    
  (function() {
    let desktopInterval = null;
    let mobileInterval = null;

    function cleanupAllIntervals() {
      if (desktopInterval) {
        clearInterval(desktopInterval);
        desktopInterval = null;
      }
      if (mobileInterval) {
        clearInterval(mobileInterval);
        mobileInterval = null;
      }
    }

    // ============ DESKTOP CAROUSEL ============
    function initDesktopCarousel(section) {
      const track = section.querySelector('#desktopTrack');
      const viewport = section.querySelector('#desktopViewport');
      const dotsContainer = section.querySelector('#desktopDots');
      const progressFill = section.querySelector('#desktopProgressFill');
      const arrowLeft = section.querySelector('#desktopArrowLeft');
      const arrowRight = section.querySelector('#desktopArrowRight');
      const mobileImageContainer = section.querySelector('#mobileImageContainer');

      if (!track) return;

      const slides = track.querySelectorAll('.consistency-carousel-slide');
      const slideCount = slides.length;
      let currentIndex = 0;

      if (slideCount === 0) return;

      // Build dots
      if (dotsContainer) {
        dotsContainer.innerHTML = '';
        for (let i = 0; i < slideCount; i++) {
          const dot = document.createElement('div');
          dot.className = 'consistency-dot' + (i === 0 ? ' active' : '');
          dot.addEventListener('click', function() {
            currentIndex = i;
            updateDesktopCarousel();
          });
          dotsContainer.appendChild(dot);
        }
      }

      function updateDesktopCarousel() {
        const offset = currentIndex * -100;
        track.style.transform = 'translateX(' + offset + '%)';

        const dots = dotsContainer.querySelectorAll('.consistency-dot');
        dots.forEach(function(dot, index) {
          if (index === currentIndex) {
            dot.classList.add('active');
          } else {
            dot.classList.remove('active');
          }
        });

        if (progressFill && slideCount > 0) {
          const progress = ((currentIndex + 1) / slideCount) * 100;
          progressFill.style.width = progress + '%';
        }

        // Sync mobile image
        if (mobileImageContainer && slides[currentIndex]) {
          const blockImage = slides[currentIndex].querySelector('.consistency-center-image img');
          if (blockImage) {
            mobileImageContainer.innerHTML = '';
            const clonedImg = blockImage.cloneNode(true);
            clonedImg.style.maxWidth = '320px';
            mobileImageContainer.appendChild(clonedImg);
          }
        }

        // Trigger animation on visible features
        const visibleSlide = slides[currentIndex];
        const features = visibleSlide.querySelectorAll('.consistency-feature');
        features.forEach(function(feature) {
          feature.classList.add('animate-on-scroll');
        });
      }

      function nextSlide() {
        currentIndex = (currentIndex + 1) % slideCount;
        updateDesktopCarousel();
      }

      function prevSlide() {
        currentIndex = (currentIndex - 1 + slideCount) % slideCount;
        updateDesktopCarousel();
      }

      // Arrow click events
      if (arrowLeft) {
        arrowLeft.addEventListener('click', prevSlide);
      }
      if (arrowRight) {
        arrowRight.addEventListener('click', nextSlide);
      }

      // Touch swipe for desktop viewport
      let startX = 0;
      viewport.addEventListener('touchstart', function(e) {
        startX = e.touches[0].clientX;
      });

      viewport.addEventListener('touchend', function(e) {
        const endX = e.changedTouches[0].clientX;
        const diff = startX - endX;

        if (Math.abs(diff) > 50) {
          if (diff > 0) {
            nextSlide();
          } else {
            prevSlide();
          }
        }
      });

      // Auto advance
      const autoAdvance = section.getAttribute('data-carousel-auto-advance') === 'true';
      const intervalSetting = parseInt(section.getAttribute('data-carousel-interval'));

      if (autoAdvance && intervalSetting) {
        if (desktopInterval) clearInterval(desktopInterval);
        desktopInterval = setInterval(nextSlide, intervalSetting * 1000);
      }

      updateDesktopCarousel();
    }

    // ============ MOBILE SLIDER ============
    function initMobileSlider(section) {
      const track = section.querySelector('#mobileSliderTrack');
      const dotsContainer = section.querySelector('#mobileDots');
      const progressFill = section.querySelector('#mobileProgressFill');
      const mobileImageContainer = section.querySelector('#mobileImageContainer');
      const desktopTrack = section.querySelector('#desktopTrack');

      if (!track) return;

      const items = track.querySelectorAll('.consistency-mobile-slider-item');
      const itemCount = items.length;
      let currentIndex = 0;

      if (itemCount === 0) return;

      // Build dots
      if (dotsContainer) {
        dotsContainer.innerHTML = '';
        for (let i = 0; i < itemCount; i++) {
          const dot = document.createElement('div');
          dot.className = 'consistency-dot' + (i === 0 ? ' active' : '');
          dot.addEventListener('click', function() {
            currentIndex = i;
            updateMobileSlider();
          });
          dotsContainer.appendChild(dot);
        }
      }

      function updateMobileSlider() {
        const offset = currentIndex * -100;
        track.style.transform = 'translateX(' + offset + '%)';

        const dots = dotsContainer.querySelectorAll('.consistency-dot');
        dots.forEach(function(dot, index) {
          if (index === currentIndex) {
            dot.classList.add('active');
          } else {
            dot.classList.remove('active');
          }
        });

        if (progressFill && itemCount > 0) {
          const progress = ((currentIndex + 1) / itemCount) * 100;
          progressFill.style.width = progress + '%';
        }

        // SYNC MOBILE IMAGE WITH SLIDER POSITION
        if (mobileImageContainer && desktopTrack) {
          const slides = desktopTrack.querySelectorAll('.consistency-carousel-slide');
          if (slides[currentIndex]) {
            const blockImage = slides[currentIndex].querySelector('.consistency-center-image img');
            if (blockImage) {
              mobileImageContainer.innerHTML = '';
              const clonedImg = blockImage.cloneNode(true);
              clonedImg.style.maxWidth = '320px';
              mobileImageContainer.appendChild(clonedImg);
            }
          }
        }
      }

      function nextSlide() {
        currentIndex = (currentIndex + 1) % itemCount;
        updateMobileSlider();
      }

      function prevSlide() {
        currentIndex = (currentIndex - 1 + itemCount) % itemCount;
        updateMobileSlider();
      }

      // Touch swipe
      let startX = 0;
      track.addEventListener('touchstart', function(e) {
        startX = e.touches[0].clientX;
      });

      track.addEventListener('touchend', function(e) {
        const endX = e.changedTouches[0].clientX;
        const diff = startX - endX;

        if (Math.abs(diff) > 50) {
          if (diff > 0) {
            nextSlide();
          } else {
            prevSlide();
          }
        }
      });

      // Auto advance
      const autoAdvance = section.getAttribute('data-mobile-slider-auto-advance') === 'true';
      const intervalSetting = parseInt(section.getAttribute('data-mobile-slider-interval'));

      if (autoAdvance && intervalSetting) {
        if (mobileInterval) clearInterval(mobileInterval);
        mobileInterval = setInterval(nextSlide, intervalSetting * 1000);
      }

      updateMobileSlider();
    }

    function initSection(section) {
      initDesktopCarousel(section);
      initMobileSlider(section);
    }

    // Shopify theme editor events
    document.addEventListener('shopify:section:load', function(e) {
      const section = e.target;
      if (section.classList.contains('consistency-section')) {
        initSection(section);
      }
    });

    document.addEventListener('shopify:section:unload', function(e) {
      const section = e.target;
      if (section.classList.contains('consistency-section')) {
        cleanupAllIntervals();
      }
    });

    document.addEventListener('DOMContentLoaded', function() {
      const sections = document.querySelectorAll('.consistency-section');
      sections.forEach(function(section) {
        initSection(section);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
